import { httpRequest } from './httpUtils';
import { Lock } from './types';

import { baseUrl, icons } from '@finnairoyj/fcom-ui-styles/index.js';

const lock: Lock = new Lock();

const cachedIcons: { [iconCategory: string]: { [iconName: string]: Promise<string> } } = {};

export interface IconCollection {
  [iconCategory: string]: string[];
}

export const getIcon = (iconName: string, iconCategory = 'svg-library'): Promise<string> => {
  if (cachedIcons[iconCategory]?.[iconName]) {
    return cachedIcons[iconCategory][iconName];
  }

  if (!icons[iconCategory]?.[iconName]) {
    return Promise.reject(new Error(`Icon "${iconName}" not found in the manifest`));
  }

  if (!cachedIcons[iconCategory]) {
    cachedIcons[iconCategory] = {};
  }

  cachedIcons[iconCategory][iconName] = httpRequest<string>({
    method: 'GET',
    url: `${baseUrl}${icons[iconCategory][iconName]}`,
    timeout: 3000,
    retries: 2,
    lock,
    withCredentials: false,
    headers: { Accept: 'image/svg+xml' },
  })
    .then((response) => response.payload)
    .catch(() => '')
    .finally(() => lock.release());

  return cachedIcons[iconCategory][iconName];
};

const DEFAULT_PRELOADED_ICONS: IconCollection = {
  'svg-library': [
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'checkmark',
    'checkbox-selected',
    'checkbox-unselected',
    'close-delete',
    'departure',
    'external-tab',
    'finnair-emblem',
    'info-block',
    'gps-location',
    'plus-outline',
    'minus-outline',
    'arrival',
    'minus',
    'switch-flights',
    'radiobutton-selected',
    'radiobutton-unselected',
    'am-logo',
    'help-block',
  ],
};

let iconPreloadingStarted = false;
export const preloadIcons = (icons = DEFAULT_PRELOADED_ICONS) => {
  if (iconPreloadingStarted) {
    return;
  }
  iconPreloadingStarted = true;
  return Promise.all(
    Object.keys(icons).reduce(
      (flatten, iconCategory) => [
        ...flatten,
        ...icons[iconCategory].map((iconName) => getIcon(iconName, iconCategory)),
      ],
      []
    )
  );
};
